import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseGroupType } from 'src/AngularJS/Models/group-type.model';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ModuleManager } from 'src/shared/models/module-manager';
import { ExpandedSummaryService } from '../../modules/expanded-summary/expanded-summary.service';

@Component({
  selector: 'cv-expanded-summary-settings',
  templateUrl: './expanded-summary-settings.component.html',
  styleUrls: ['./expanded-summary-settings.component.scss']
})
export class ExpandedSummarySettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;
    
    public context: string;
    
    public initialized: boolean = false;
    
    public selectedPrimaryView: number = BaseGroupType.Employee;
    public selectedEmpGroup: number = 0;
    public selectedRecGroup: number = 0;
    
    public empGroups: string[];
    public recGroups: string[];
    
    private empGroupLocalizedName: string;
    private recGroupLocalizedName: string;

    constructor(
        private cvLocalizationService: CVLocalizationService,
        private expandedSummaryService: ExpandedSummaryService
    ) { }

    async ngOnInit() {
        await this.cvLocalizationService.GetSection('Expanded_Summary');
        
        this.empGroupLocalizedName = this.cvLocalizationService.getCachedText('Expanded_Summary', 'Employee_Group', 'Employee Group');
        this.recGroupLocalizedName = this.cvLocalizationService.getCachedText('Expanded_Summary', 'Contact_Group', 'Contact Group');
        
        var settings = await this.expandedSummaryService.getSettings(this.moduleManager.getModuleKey());
        this.empGroups = settings.EmpGroups;
        this.recGroups = settings.RecGroups;
        
        this.onPrimaryViewChange();
        
        this.moduleManager.addSetting({
            name: "PrimaryView",
            required: true,
            getValue: () => this.selectedPrimaryView,
            onSettingLoaded: (value) => {
                this.selectedPrimaryView = value ?? 0;
                this.onPrimaryViewChange();
            },
        });
        
        this.moduleManager.addSetting({
            name: "EmpGroup",
            required: true,
            getValue: () => this.selectedEmpGroup,
            onSettingLoaded: (value) => this.selectedEmpGroup = value ?? 0,
        });
        
        this.moduleManager.addSetting({
            name: "RecGroup",
            required: true,
            getValue: () => this.selectedRecGroup,
            onSettingLoaded: (value) => this.selectedRecGroup = value ?? 1,
        });

        this.moduleManager.customSettingsAdded = true;
        this.initialized = true;
    }
    
    public onPrimaryViewChange() {
        if (this.selectedPrimaryView == BaseGroupType.Employee)
            this.context = `${this.empGroupLocalizedName}, ${this.recGroupLocalizedName}`;
        else
            this.context = `${this.recGroupLocalizedName}, ${this.empGroupLocalizedName}`;
    }
}
